/**
 *
 * Asynchronously loads the component for ApplicantUploadFileModal
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
